<template>
    <b-form data-vv-scope="form-sga" @submit.prevent="onHandleStoreSga">
        <b-row>

            <!-- PICTOGRAMAS -->
            <b-col sm="12" class="text-center" v-if="pictograms.pictogramsHomologation.length">
                <h4>PICTOGRAMAS</h4>
                <b-img v-for="(pictograma, index) in pictograms.pictogramsHomologation"
                    class="m-2"
                    :key="index"
                    thumbnail
                    fluid
                    :src="pictograma.direccion"
                    :alt="pictograma.pictograma"
                    style="max-width: 80px; max-height: 80px"
                />
                <hr/>
            </b-col>

            <!-- Peligros Físicos -->
            <b-col md="6">
                <b-badge class="w-100 badge-sga badge-fisicos">Peligros Físicos</b-badge>
                <el-select v-model="selectedSga.categoriasfisicas"
                           id="categoriasfisicas"
                           name="categoriasfisicas"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(selectedSga.categoriasfisicas, 'fisicas')"
                           @input="verifyCategory(fisicos.filter(fisico => selectedSga.categoriasfisicas.includes(fisico.id)))"
                           :disabled="desactivar_edicion && administrarSga"
                >
                    <el-option v-for="(fisico, index) in fisicos"
                               :key="index"
                               :value="fisico.id"
                               :label="fisico.categoria"
                    />
                </el-select>

                <span class="text-danger span-error small"
                      v-text="errors.first('form-sga.categoriasfisicas')"
                />
                <b-alert
                    v-if="isAddH229"
                    variant="info"
                    show
                    class="custom-alert-category">
                    <span>
                        Al seleccionar la frase <strong>H222</strong> o <strong>H223</strong>,
                        se agregará automáticamente la frase <strong>H229</strong> (Aerosoles, categoría 3).
                    </span>
                </b-alert>

            </b-col>

            <!-- Peligros de Salud -->
            <b-col md="6">
                <b-badge class="w-100 badge-sga badge-salud">Peligros de Salud</b-badge>
                <el-select v-model="selectedSga.categoriassalud"
                           id="categoriassalud"
                           name="categoriassalud"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(selectedSga.categoriassalud, 'salud')"
                           :disabled="desactivar_edicion && administrarSga"
                >
                    <el-option v-for="(saludcat, index) in salud"
                               :key="index"
                               :value="saludcat.id"
                               :label="saludcat.categoria"
                    />
                </el-select>

                <span class="text-danger span-error small"
                      v-text="errors.first('form-sga.categoriassalud')"
                />
            </b-col>

            <!-- Peligros en el Ambiente -->
            <b-col md="6">
                <b-badge class="w-100 badge-sga badge-ambiente">Peligros en el Ambiente</b-badge>
                <el-select v-model="selectedSga.categoriasambiental"
                           id="categoriasambiental"
                           name="categoriasambiental"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(selectedSga.categoriasambiental, 'ambiental')"
                           :disabled="desactivar_edicion && administrarSga"
                >
                    <el-option v-for="(ambiente, index) in ambiental"
                               :key="index"
                               :value="ambiente.id"
                               :label="ambiente.categoria"
                    />
                </el-select>

                <span class="text-danger span-error small"
                      v-text="errors.first('form-sga.categoriasambiental')"
                />
            </b-col>

            <!-- Sustancias no peligrosas -->
            <b-col md="6">
                <b-badge class="w-100 badge-sga badge-no-peligrosas">Sustancias no peligrosas</b-badge>
                <el-select v-model="selectedSga.categoriasNpeligrosas"
                           id="categoriasNpeligrosas"
                           name="categoriasNpeligrosas"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(selectedSga.categoriasNpeligrosas, 'nopeligrosas')"
                           :disabled="desactivar_edicion && administrarSga"
                >
                    <el-option v-for="(peligrosa, index) in getNonHazardousSubstances"
                               :key="index"
                               :value="peligrosa.id"
                               :label="peligrosa.categoria"
                    />

                </el-select>

                <span class="text-danger span-error small"
                      v-text="errors.first('form-sga.categoriasNpeligrosas')"
                />
            </b-col>

            <!-- Guardar cambios -->
            <b-col md="12" v-if="opcionGuardar && !isActionCreateWithIA && validarPermisoComponente('editar-sistemas-clasificacion-productos-nuevo-y-antiguo')" class="text-center">
                <hr/>
                <b-button variant="primary"
                    @click="onHandleStoreSga()"
                    v-if="!desactivar_edicion && administrarSga"
                >
                    <i class="fa fa-floppy-o"/> Guardar cambios
                </b-button>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import { validarPermisoComponente } from '../../../plugins/acl';
import Swal from 'sweetalert2';
export default {
    name: 'sga',
    data() {
        return {
            administrarSga: false,
            valuesNoApply: {
              environmental: false,
              physical: false,
              health: false,
          },
           isAppliedSgaCategoriesDangers: false,
           isAddH229: false,
           validarPermisoComponente: validarPermisoComponente,
        }
    },
    props:{
        desactivar_edicion: {
            type: Boolean,
            default: false,
            required: false
        },
        isActionCreateWithIA: {
            default: false,
            required: false
        }
    },
    computed: {
        ...mapState('sga', [
            'selectedSga',
            'fisicos',
            'salud',
            'ambiental',
            'peligrosas',
            'pictograms',
            'seeCHealthEffects'
        ]),
        ...mapState('productos', [
            'esEmpresaContratista',
            'opcionGuardar',
            'selectedProduct',
            'producto_nuevo',
            'sgaReadFds'
        ]),
      verifySgaHasNoApply() {

        let environmentalNA =  false
        let physicalNA =  false
        let healthNA =  false

        if (this.valuesNoApply.environmental && typeof this.selectedSga.categoriasambiental === 'object') {
          const hasEnvironmentalNA = this.selectedSga.categoriasambiental.find(x => x == this.valuesNoApply.environmental.id)
          if (hasEnvironmentalNA || this.selectedSga.categoriasambiental.length == 0) environmentalNA = true
          if (this.selectedSga.categoriasambiental.length > 0 && !hasEnvironmentalNA) environmentalNA = false
        }


        if (this.valuesNoApply.physical && typeof this.selectedSga.categoriasfisicas === 'object') {
          const hasPhysicalNA = this.selectedSga.categoriasfisicas.find(x => x == this.valuesNoApply.physical.id)
          if (hasPhysicalNA || this.selectedSga.categoriasfisicas.length == 0) physicalNA = true
          if (this.selectedSga.categoriasfisicas.length > 0 && !hasPhysicalNA) physicalNA = false
        }


        if (this.valuesNoApply.health && typeof this.selectedSga.categoriassalud === 'object') {
          const hasHealthNa = this.selectedSga.categoriassalud.find(x => x == this.valuesNoApply.health.id)
          if (hasHealthNa || this.selectedSga.categoriassalud.length == 0) healthNA = true
          if (this.selectedSga.categoriassalud.length > 0 && !hasHealthNa) healthNA = false
        }

        return (!environmentalNA || !physicalNA || !healthNA) ? false : true;
      },

      getNonHazardousSubstances() {
        return this.isActionCreateWithIA ?
            (!this.isAppliedSgaCategoriesDangers ? this.peligrosas : this.peligrosas.filter(item => item.codigo == "NA"))
            : this.peligrosas.filter(item => this.verifySgaHasNoApply ? item.codigo != "NA" : item.codigo == "NA")
      },
      currentActionEdit() {
        return this.$route.meta.breadcrumb == "/productos/ver"
      }
    },
    created() {
        this.administrarSga = validarPermisoComponente('editar-sistemas-clasificacion-productos-nuevo-y-antiguo');
    },
    async mounted() {

        this.restablecerSga()
        this.setGuardado(false);
        await this.getJsonSga();

        // Id del producto activo.
        const id = this.currentActionEdit ? this.$route.params.id : this.selectedProduct.Idproducto;

        /**
         * Cargar los pictogramas del SGA.
         *
         * @author Fernando Claros
         */
        if (!this.isActionCreateWithIA && id) await this.getPictogramsOfSga(id);
        else {
            // Setear la data de los pictogramas.
            this.setSgaPictogramas({
                homologacion: [],
                clasificacion: []
            });
            this.setPictograms({
                pictogramsClassification: [],
                pictogramsHomologation: []
            });
        }

        /**
         * Cargar el SGA.
         *
         * @author Fernando Claros
         */
        if (!this.isActionCreateWithIA) await this.getDataSga(id).then(() => this.getValuesNoApply());

        if(this.isActionCreateWithIA) {

            let sgaDefaultData = {
                categoriasfisicas: [],
                categoriassalud: [],
                categoriasambiental: [],
                categoriasNpeligrosas: []
            };

            let hasDangers = false;

            // Leyendo Pdf con IA & los SGA encontrados están vacíos
            if (typeof this.sgaReadFds !== 'object' || this.sgaReadFds.length <= 0) {
                sgaDefaultData.categoriasfisicas = [1]
                sgaDefaultData.categoriassalud = [51]
                sgaDefaultData.categoriasambiental = [92]
                sgaDefaultData.categoriasNpeligrosas = [103]
            }

            // Con SGA del pdf - IA
            else {
                this.sgaReadFds.map(item => {
                    const temporaryPhysical = this.fisicos.find(x => x.codigo == item.code)
                    if (temporaryPhysical) {
                        hasDangers = true;
                        sgaDefaultData.categoriasfisicas.push(temporaryPhysical.id)
                    }

                    const temporaryEnvironmental = this.salud.find(x => x.codigo == item.code)
                    if (temporaryEnvironmental) {
                        hasDangers = true;
                        sgaDefaultData.categoriassalud.push(temporaryEnvironmental.id)
                    }

                    const temporaryHealth = this.ambiental.find(x => x.codigo == item.code)
                    if (temporaryHealth) {
                        hasDangers = true;
                        sgaDefaultData.categoriasambiental.push(temporaryHealth.id)
                    }
                })
            }

            if (hasDangers) {
                this.isAppliedSgaCategoriesDangers = true
                sgaDefaultData.categoriasNpeligrosas = [101]

                if (sgaDefaultData.categoriasfisicas.length <= 0) sgaDefaultData.categoriasfisicas = [1]
                if (sgaDefaultData.categoriassalud.length <= 0) sgaDefaultData.categoriassalud = [51]
                if (sgaDefaultData.categoriasambiental.length <= 0) sgaDefaultData.categoriasambiental = [92]
            }

            this.setSga(sgaDefaultData);
        }
    },
    methods: {
        ...mapMutations('sga', [
            'setGuardado',
            'setTabActivoSga',
            'restablecerSga',
            'setSga',
            'setSgaPictogramas',
            'setPictograms',
            'cargarJsonSga'
        ]),
        ...mapActions('sga', [
            'getJsonSga',
            'getSga',
            'getFrases',
            'storeSga',
            'getPictogramsOfSga',
            'getDataSga'
        ]),
        ...mapActions('productos', ['actualizaProducto']),
        ...mapActions('hmis', ['getOpciones']),

        async valores(selectedSga, tipo) {
            if (tipo === 'fisicas') {
                for (let i = 0; i < selectedSga.length; i++) {
                    // Si es 1 significa que no aplica
                    if (selectedSga[i] == 1) {
                        this.selectedSga.categoriasfisicas = [];
                        this.selectedSga.categoriasfisicas.push(1);
                    }
                }
            }
            if (tipo === 'salud') {
                for (let i = 0; i < selectedSga.length; i++) {
                    if (selectedSga[i] == 51) {
                        this.selectedSga.categoriassalud = [];
                        this.selectedSga.categoriassalud.push(51);
                    }
                }
            }
            if (tipo === 'ambiental') {
                for (let i = 0; i < selectedSga.length; i++) {
                    if (selectedSga[i] == 92) {
                        this.selectedSga.categoriasambiental = [];
                        this.selectedSga.categoriasambiental.push(92);
                    }
                }
            }
            if (tipo === 'nopeligrosas') {
                for (let i = 0; i < selectedSga.length; i++) {
                    if (selectedSga[i] == 101) {
                        this.selectedSga.categoriasNpeligrosas = [];
                        this.selectedSga.categoriasNpeligrosas.push(101);
                    }
                }
            }
        },
        /**
         * Guardar cambios del SGA.
         *
         * @author Fernando Claros
         */
        async onHandleStoreSga() {
            this.$validator.validateAll('form-sga').then(async (result) => {
                if (!result) return false;

                const payload = {
                    id: this.$route.params.id,
                    sga: {
                        categoriesPhysical: this.selectedSga.categoriasfisicas,
                        categoriesHealth: this.selectedSga.categoriassalud,
                        environmentalCategories: this.selectedSga.categoriasambiental,
                        categoriesHazardous: this.selectedSga.categoriasNpeligrosas
                    }
                };

                if(this.seeCHealthEffects) {
                    this.$alertConfirmation({
                        icon: "warning",
                        title:  "Actualizar efectos a la salud",
                        text: "¿Quiere actualizar los efectos a la salud de acuerdo a la clasificación SGA?",
                        showConfirmButton: true,
                        showCancelButton: true,
                        titleBtnConfirm: "Si",
                        titleBtnCancel: "No",
                        onConfirm: async () => {
                            payload.sga.canUpdateHeatlEffects = true;
                            await this.storeSga(payload);
                            await this.getDataSga(this.$route.params.id);
                        },
                        onCancel:async () => {
                            payload.sga.canUpdateHeatlEffects = false;
                            await this.storeSga(payload);
                            await this.getDataSga(this.$route.params.id);
                        },
                    });
                } else{
                    await this.storeSga(payload);
                    await this.getDataSga(this.$route.params.id);
                }
            });
        },
      getValuesNoApply() {
        this.valuesNoApply.physical = this.fisicos.find(x => x.codigo == "NA")
        this.valuesNoApply.health = this.salud.find(x => x.codigo == "NA")
        this.valuesNoApply.environmental = this.ambiental.find(x => x.codigo == "NA");
      },
      verifyCategory(categories) {
        const codes = categories.map(category => category.codigo);
        this.isAddH229 = codes.includes("H222") || codes.includes("H223");
      }
    },
};
</script>

<style>
.badge-sga {
    border-radius: 8px;
    height: 40px;
    color: white;
    padding: 14px;
    font-size: 14px;
    margin-top: 15px;
}

.badge-fisicos {
    background-color: #ff7d00;
}

.badge-salud {
    background-color: #1f487b;
}

.badge-ambiente {
    background-color: #36b564;
}

.badge-no-peligrosas {
    background-color: #55b543;
}

.custom-alert-category {
    color: #333;
    text-align: center;
    padding: 0.5rem;
    background-color: #f0f8ff;
    border: 1px solid #b3e5fc;
    border-radius: 6px;
    font-size: 0.75rem;
    box-shadow: none;
}
</style>
